import * as React from 'react';
import { mergeDeepRight } from 'ramda';
import { ChartConfiguration } from 'chart.js';

import { getGradientFirstLine, getGradientSecondLine } from './getChartLineGradient';
import { BASE_CONFIG, mergeDataWithBaseDataset, yAxisTicksCb, tooltipLabelCb } from './chartConfiguration';
import { EChartType, IChartConfigOptions } from '../../../types/charts';
import { getCorrectSpace } from './getCorrectSpace';

export const usePrepareChartConfig = (ctx: CanvasRenderingContext2D | null, options: IChartConfigOptions) => {
  return React.useMemo(() => {
    if (!ctx) {
      return null;
    }

    const gradientFirstLine = getGradientFirstLine(ctx, options.chartHeight);
    const gradientSecondLine = getGradientSecondLine(ctx, options.chartHeight);

    const firstLine = mergeDataWithBaseDataset(1, {
      data: options.firstLineValues,
      label: options.firstLabel,
      backgroundColor: gradientFirstLine,
    });

    const secondLine = mergeDataWithBaseDataset(0, {
      data: options.secondLineValues,
      label: options.secondLabel,
      backgroundColor: gradientSecondLine,
    });

    const datasets = [firstLine, secondLine];

    return mergeDeepRight(BASE_CONFIG, {
      data: {
        labels: options.datesLabels,
        datasets,
      },
      options: {
        scales: {
          y: {
            min: options.minChartValue,
            max: options.maxChartValue,
            ticks: {
              stepSize: options.labelStep,
              /**
               * Это один из хачных хаков, который писался под ночь после созвона с нашим PO))
               * Сергей сказал, что это временно
               * TODO: переписать либо удалить, когда станет ясно, что с этим делать
               * */
              callback:
                // istanbul ignore next
                options.chartType === EChartType.OffersViewed || options.chartType === EChartType.OffersCount
                  ? () => ''
                  : yAxisTicksCb(options.priceUnit, getCorrectSpace(options.chartType)),
            },
          },
          x: {
            ticks: {
              maxTicksLimit: options.datesLabels ? options.datesLabels.length : 120,
            },
          },
        },
        onHover: options.onHover,
        tooltips: {
          callbacks: {
            /**
             * Это второй из хачных хаков, который писался под ночь после созвона с нашим PO))
             * Сергей сказал, что это временно
             * TODO: переписать либо удалить, когда станет ясно, что с этим делать
             * */
            label:
              // istanbul ignore next
              options.chartType === EChartType.OffersViewed || options.chartType === EChartType.OffersCount
                ? () => ''
                : tooltipLabelCb(options.priceUnit, getCorrectSpace(options.chartType)),
          },
        },
      },
    }) as ChartConfiguration;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ctx,
    options.firstLineValues,
    options.firstLabel,
    options.secondLineValues,
    options.secondLabel,
    options.datesLabels,
    options.minChartValue,
    options.maxChartValue,
    options.labelStep,
    options.priceUnit,
    options.chartType,
  ]);
};
